<template>
    <div class="modal fade" id="addChequePaymentModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">افزودن پرداخت چک </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="content-section default">
                                <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                                    <li v-for="error in errors.all()">{{ error }}</li>
                                </ul>
                                <form @submit.prevent="addCashPayment" class="form-account">

                                    <div class="row">
                                        <div class="col-sm-12 col-md-12">
                                            <file-Preview-from @getInputImage="GetUrlImage"></file-Preview-from>
                                        </div>
                                            <div class="col-sm-6 col-md-6 pull-left">
                                                <div class="form-account-title">کد صیادی</div>
                                                <div class="form-account-row">
                                                    <input v-model="chequePaymentInfo.ChequeCode" v-validate="{ max:16 , min:16  }" data-vv-as="کد صیادی" class="input-field" placeholder="کد صیادی را وارد کنید">
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-6 pull-left">
                                                <div class="form-account-title">کد ملی صاحب چک</div>
                                                <div class="form-account-row">
                                                    <input v-model="chequePaymentInfo.ChequeHolderNationalCode" v-validate="{ max:50  }" data-vv-as="کد ملی صاحب چک" class="input-field" placeholder="کد ملی صاحب چک را وارد کنید">
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-6 pull-right">
                                                <div class="form-account-title">مبلغ چک (ریال)</div>
                                                <div class="form-account-row">
                                                    <vue-numeric v-model="chequePaymentInfo.Amount" v-validate="{required:true,numeric:true,min:3,max:10}" data-vv-as="مبلغ چک" class="input-field" placeholder="مبلغ چک خود را وارد کنید" separator=","></vue-numeric>
                                                </div>
                                            </div>

                                            <div class="col-sm-6 col-md-6 pull-right">
                                                <div class="form-account-title">تاریخ سررسید</div>
                                                <div class="form-account-row">
                                                    <custom-date-picker v-model="chequePaymentInfo.DueDate" v-validate="{regex:/^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/ }" data-vv-as="تاریخ سررسید" />
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-12">
                                                <div class="form-account-title">توضیحات</div>
                                                <div class="form-account-row">
                                                    <textarea rows="2" v-model="chequePaymentInfo.CustomerComment" class="input-field" placeholder="توضیحات"></textarea>
                                                </div>
                                            </div>
                                         
                                        
                                    </div>
                                    <div class="col-12 text-center">
                                        <button style="margin-left:5px;margin-right:5px;" type="submit" class="btn btn-default btn-lg btn-save">ذخیره</button>
                                        <button style="margin-left:5px;margin-right:5px;" data-dismiss="modal" class="btn btn-default btn-lg btn-reject">انصراف</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="{loader: !isShowLoader, 'loader-bg-black':true}">
                    <img src="/assets/img/loader/loader.svg" />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    import { chequePaymentChangedEventBus } from "../../eventBus/eventBus";
    import filePreviewform from "./filePreviewform";


    export default {

        data() {
            return {
                chequePaymentInfo: { hashOrderId: this.$route.params.hashOrderId, Amount:''},
                isShowLoader: false,
                picPath: null,
                settings: {
                    decimal: '-',
                    thousands: '.',


                } 
            }
        },
        components: {
            'file-Preview-from': filePreviewform,
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
        },
        methods: {
            GetUrlImage(value) {
                this.picPath = value;
            },
            addCashPayment() {
                this.chequePaymentInfo.PicPath = this.picPath;
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowLoader = true;
                        httpPromise(this, '/v1/Orders/ColleagueOrderChequePayments/Add', 'Post', JSON.stringify(this.chequePaymentInfo),
                            response => {
                                toastr.remove();
                                toastr.success(response.data.Message);
                                chequePaymentChangedEventBus.$emit('readOrdersMethod', '');
                                this.isShowLoader = false;
                                $(function () {
                                    $('#addChequePaymentModal').modal('hide');
                                });
                                this.chequePaymentInfo = {};
                                this.chequePaymentInfo.hashOrderId = this.$route.params.hashOrderId;
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowLoader = false;
                            });
                    }
                });
            },
            resetForm() {
                this.$validator.reset();
                this.$validator.errors.clear();
            },

        },
        created() {

            var resetForm = this.resetForm;
            $(function () {

                $('#addChequePaymentModal').on("hidden.bs.modal", function (event) {
                    resetForm();
              
                });
            });
        },
        beforeDestroy() {

        },
    }
</script>

<style scoped>
    .vpd-icon-btn {
 
        margin-bottom: 0;
    }
    .loader-bg-black {
        position: absolute;
        background-color: #80808033;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        width: 100%;
        height: 100%
    }

        .loader-bg-black img {
            position: absolute;
            top: 50%;
            left: 48%;
            z-index: 100
        }

    .btn-save {
        background-color: #59b959 !important;
    }

    .btn-reject {
        background-color: #e36e6e !important;
    }

    .input-field {
        padding: 11px 11px 11px 11px !important;
    }

    .modal-content .modal-header button {
        right: unset !important;
        left: 27px !important;
        top: 30px !important;
    }

    .modal-header .close {
        padding: unset !important;
        margin: -1rem -1rem -1rem auto;
    }

    .setaddress {
        padding: 22px !important;
    }

    a:not([href]):not([tabindex]) {
        color: #fff;
    }

    .box.profile .center {
        text-align: center;
    }

    .box.no-address .desc {
        display: block;
        margin: 0 auto;
    }

    .box.profile.no-address img {
        margin-bottom: 25px;
    }

    .box.no-address {
        text-align: center;
        color: #777777;
    }

    .address-div {
        display: contents;
    }

    .box profile {
        min-height: 200px;
        width: auto;
    }

    .box {
        background: #fcfcfc;
        border: 1px solid #e5e5e5;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        padding: 15px;
        width: 100%;
        margin-top: 15px;
    }

        .box .title {
            display: block;
            font-weight: 500;
            text-align: center;
        }

        .box .location {
            font-size: 12px;
            color: #777777;
            display: block;
            text-align: center;
            margin-top: 5px;
        }

        .box .desc {
            margin-top: 15px;
            text-align: center;
            display: block;
            font-size: 12px;
        }

        .box.profile .center {
            text-align: center;
        }

    .btn-lg {
        padding: 10px 25px;
    }
</style>